/*
function fadeIn(el, time) {
    el.style.opacity = 0;

    let last = +new Date();
    let tick = function() {
        el.style.opacity = +el.style.opacity + (new Date() - last) / time;
        last = +new Date();

        if (+el.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
    };

    tick();
}

function fadeOut(el, time) {
    el.style.opacity = 1;

    let last = +new Date();
    let tick = function() {
        el.style.opacity = +el.style.opacity - (new Date() - last) / time;
        last = +new Date();

        if (+el.style.opacity > 0) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
    };

    tick();
}

/!*function scrollTo(pos) {
    let start = null,
        w = window.pageYOffset;

    function step(time) {
        if (start === null) start = time;
        let progress = time - start,
            r = (pos < 0 ? Math.max(w - progress / V, w + pos) : Math.min(w + progress / V, w + pos));
        window.scrollTo(0, r);
        if (r != w + pos) {
            requestAnimationFrame(step)
        }
    }

    requestAnimationFrame(step);
}*!/

function scrollTo (pos) {
    var st = pageYOffset
    var d = pos;
    var s = d / 1000
    var pt = performance.now()

    var p = document.querySelector('main');

    requestAnimationFrame(function f(t) {
        var cur = p.scrollTop = st + s * (t - pt)
        if (s<0 ? cur > st + d : cur < st + d) requestAnimationFrame(f)
        else requestAnimationFrame(() => p.scrollTop = st + d)
    })
}

let lastScrollTop = 0;

window.addEventListener('scroll', function onScroll (e) {
    let top = window.pageYOffset;
    if (lastScrollTop > top)
        scrollTo(0);
    else
        scrollTo('100vh');
    lastScrollTop = top;
});*/

let lastScrollTop = 0;
let isScrolling = false;

function onScroll () {
    if (!isScrolling) {
        isScrolling = true;
        let pos = $(this).scrollTop();
        const num = Math.round(lastScrollTop/$(window).height());

        if (pos > lastScrollTop) {
            let scrollTop = $(window).height() * (num+1);
            $('html, body').animate({scrollTop: scrollTop}, 300, function () {
                if (isScrolling) {
                    lastScrollTop += $(window).height();
                    isScrolling = false;
                }
            });
            $(`section:nth-child(${(num+2)})`).fadeIn(200);
        } else if (pos < lastScrollTop) {
            let scrollTop = $(window).height() * (num-1);
            $('html, body').animate({scrollTop: scrollTop}, 300, function () {
                if (isScrolling) {
                    lastScrollTop -= $(window).height();
                    isScrolling = false;
                }
            });
            $(`section:nth-child(${(num+1)})`).fadeOut(200);
        } else  {
            isScrolling = false;
        }
    }
}
$(() => {
    if ($(window).width() > 575)
        $(window).on('scroll', onScroll);
});

